import React from 'react';
import botBg from '../../asset/choose/choose-bg-bot.png';
import leftBg from '../../asset/choose/choose-left-top.png';
import rightBg from '../../asset/choose/choose-right-top.png';
import './index.less';
import { useStatistics } from '../../utils/statistics';
export function CommonBg(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    title = _ref.title,
    content = _ref.content,
    footer = _ref.footer;
  useStatistics('CommonBg');
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-common-bg")
  }, /*#__PURE__*/React.createElement("img", {
    src: botBg,
    className: "login-common-bg-bg-bot",
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: leftBg,
    className: "login-common-bg-bg-left",
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: rightBg,
    className: "login-common-bg-bg-right",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-common-bg-content-wrap"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "login-common-bg-title fontBold"
  }, title), content && /*#__PURE__*/React.createElement("div", {
    className: "login-common-bg-content"
  }, content), footer && /*#__PURE__*/React.createElement("div", {
    className: "login-common-bg-content-bot"
  }, footer)));
}